function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16.65",
  viewBox: "0 0 15 16.65",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.67 6.65V15h11.66V6.65H10V5h5v11.66H0V5h5v1.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.33 0H6.67v10.04l-2.12-2.1L3.37 9.1l4.13 4.13 4.12-4.13-1.17-1.18-2.12 2.12z"
}))));